export const endpoints = Object.freeze({
  loginLocal: () => '/auth/oauth/token',
  auto1Auth: () => '/en/app/user-token/obtain-token',
  googleAuth: () => '/pav3-web-app/api/auth/google',
  logout: () => '/logout',
});
